import PropTypes from 'prop-types';
import React from 'react';
import { truncateWithEllipsis } from '../../../utilities/ui_utilities';
import FGBLabel from '../../Elements/FGBLabel/FGBLabel';
import ResponsivePicture, {
    BREAKPOINT_SHAPE,
} from '../../Elements/ResponsivePicture/ResponsivePicture';
import './ArticleCard.scss';

export default class ArticleCard extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        wink: PropTypes.string,
        contentImage: PropTypes.shape({
            src: PropTypes.string,
            alt: PropTypes.string,
            title: PropTypes.string,
            credit: PropTypes.string,
        }),
        title: PropTypes.string,
        url: PropTypes.string,
        contentBody: PropTypes.string,

        /**
         * The max width of the image for each device type, DEPRECATED, use pictureBreakpoints instead
         */
        maxWidth: PropTypes.shape({
            tablet: PropTypes.number,
            desktop: PropTypes.number,
            mobile: PropTypes.number,
        }),

        pictureBreakpoints: BREAKPOINT_SHAPE,
        descriptionCharMax: PropTypes.number,
    };

    static defaultProps = {
        pictureBreakpoints: null,
        descriptionCharMax: 135,
    };

    mapMaxWidthToBreakpoints = (maxWidth) => {
        // for backwards compatibility.
        // This converts the old maxWidth prop that the ResponsiveImage component expected to the breakpoints format that ResponsivePicture uses.
        const keys = Object.keys(maxWidth);
        const output = {};
        keys.map((key) => {
            output[key] = { width: maxWidth[key] };
        });
        return output;
    };

    getBreakpoints = () => {
        return (
            this.props.pictureBreakpoints ||
            (this.props.maxWidth &&
                this.mapMaxWidthToBreakpoints(this.props.maxWidth)) || {
                desktop: { width: 288 },
            }
        );
    };

    renderWink = () => <FGBLabel>{this.props.wink}</FGBLabel>;

    renderContentImage = () => (
        <ResponsivePicture
            breakpoints={this.getBreakpoints()}
            cloudinaryID={this.props.contentImage.src}
            alt={this.props.contentImage.alt}
        />
    );

    renderTitle = () => (
        <div className="articleCardTitle">
            {truncateWithEllipsis(this.props.title, 110)}
        </div>
    );

    renderContentBody = () => {
        const {
            contentBody,
            descriptionCharMax,
            showReadMore,
            url,
        } = this.props;
        const isDescriptionTruncated =
            contentBody && contentBody.length > descriptionCharMax;
        const shouldShowReadMore = url && isDescriptionTruncated;
        const showWhiteSpace = showReadMore ? ' ' : '';

        return (
            <div className="articleCardContentBody">
                {truncateWithEllipsis(
                    this.props.contentBody,
                    this.props.descriptionCharMax
                )}
                {showWhiteSpace}
                {shouldShowReadMore && (
                    <span className="read-more">Read more</span>
                )}
            </div>
        );
    };

    render() {
        const wink = this.props.wink ? this.renderWink() : null;
        const contentImage = this.props.contentImage
            ? this.renderContentImage()
            : null;
        const contentTitle = this.props.title ? this.renderTitle() : null;
        const contentBody = this.props.contentBody
            ? this.renderContentBody()
            : null;
        const content = (
            <div>
                {wink}
                {contentImage}
                {contentTitle}
                {contentBody}
            </div>
        );
        const determineContent = this.props.url ? (
            <a href={this.props.url} className="card-link">
                {content}
            </a>
        ) : (
            content
        );
        return (
            <div className="component-Community-ArticleCard">
                {determineContent}
            </div>
        );
    }
}
